import { render, staticRenderFns } from "./ThirdPartyCompanies.vue?vue&type=template&id=495eeb2c&scoped=true"
import script from "./ThirdPartyCompanies.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyCompanies.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyCompanies.vue?vue&type=style&index=0&id=495eeb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495eeb2c",
  null
  
)

export default component.exports